// import axios from 'axios'
import { post, put, get } from "@/api/api";

export const actions = {
  fetchTemoins({ commit }) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/temoin`).then(({ data }) => {
      commit("addTemoins", data);
    });
  },
  async fetchTemoinsPage({ commit }, params = {}) {
    const { page = 0, size = 10, sort = '', code = '', qr = '', numero = '', filmTitle = '', nameSalle = '', idSalle = '', preShowStartTime = '', afterHoraire = '', beforeHoraire = '', screen = '', idScreen = '', idAgregateur = '', after = '', before = '' } = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort,
      ...(code && { code }),
      ...(qr && { qr }),
      ...(numero && { numero }),
      ...(filmTitle && { filmTitle }),
      ...(nameSalle && { nameSalle }),
      ...(idSalle && { idSalle }),
      ...(preShowStartTime && { preShowStartTime }),
      ...(afterHoraire && { afterHoraire }),
      ...(beforeHoraire && { beforeHoraire }),
      ...(screen && { screen }),
      ...(idScreen && { idScreen }),
      ...(idAgregateur && { idAgregateur }),
      ...(after && { after }),
      ...(before && { before }),
    }).toString();

    let { data } = await get(`/canal/temoin/page?${queryParams}`);
    commit("addTemoinsPage", data)
    return data;
  },
  createTemoin({ commit }, temoin) {
    return post("/canal/temoin", temoin).then(({ data }) => {
      commit("addTemoin", data);
    });
  },
  updateTemoin({ commit }, temoin) {
    return put(`/canal/temoin${temoin.id}`, temoin).then(({ data }) => {
      commit("replaceTemoin", data);
    });
  },
  createOrUpdateTemoin({ dispatch }, temoin) {
    if (temoin.id !== undefined) {
      return dispatch("updateTemoin", temoin);
    } else {
      return dispatch("createTemoin", temoin);
    }
  },
  selectTemoin({ commit }, temoin) {
    commit("setTemoin", temoin);
  },
  async downloadFile(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const { data } = await get(`/canal/temoin/exportToExcel?${queryParams}`, {
        responseType: 'blob' 
      });

      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `resultats_recherche.xlsx`; 
      document.body.appendChild(link);

      link.click(); 
      document.body.removeChild(link); 

      URL.revokeObjectURL(url); 
    } catch (error) {
      console.error("Erreur lors du téléchargement :", error);
    }
  }


};
